export const metricLabels = {
  callsWaiting: "CALLS WAITING",
  agentsOnline: "AGENTS ON CONTACT",
  missedCalls: "MISSED CALLS",
  abandonedCalls: "ABANDONED CALLS",
  avgWaitTime: "AVERAGE WAIT TIME",
  avgTalkTime: "AVERAGE TALK TIME",
  answeredCalls: "ANSWERED CALLS",
  totalCalls: "TOTAL CALLS",
  longestWait: "LONGEST WAIT TODAY",
  abandonmentRate: "ABANDONMENT RATE",
};